import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms'
import { TimeframeWithLocalTimes } from '@ftr/contracts/api/shared'
import { LocalTime } from '@js-joda/core'
import { allOrNothing, isStartAfterEnd } from './time-range-control.validators'

export interface TimeRangeControlFormValue {
  start: LocalTime | null
  end: LocalTime | null
}

export interface TimeRangeControlForm {
  start: FormControl<LocalTime | null>
  end: FormControl<LocalTime | null>
}

/**
 * timeframe = default timeframe
 * input validation = individual fields, eg min/max times etc.
 * range validation = validation for the whole range (eg. checking for overlaps etc.)
 */
export class TimeRangeControl extends FormGroup<TimeRangeControlForm> {
  constructor(timeframe?: TimeframeWithLocalTimes, inputValidation?: ValidatorFn[], rangeValidation?: ValidatorFn[]) {
    super(
      {
        start: new FormControl<LocalTime | null>(timeframe?.start ?? null, inputValidation),
        end: new FormControl<LocalTime | null>(timeframe?.end ?? null, inputValidation),
      },
      [isStartAfterEnd(), allOrNothing(inputValidation), ...(rangeValidation ?? [])],
    )
  }
}

export function isTimeRangeControl(control: AbstractControl): control is TimeRangeControl {
  return control instanceof TimeRangeControl
}

/**
 * Pretty key method. Given a "raw" form value, we can type check that it's got values for start and end.
 *
 * This means we can type as a valid TimeframeWithLocalTimes after this check
 */
export function isFilledOut(timeframe: Partial<TimeRangeControlFormValue>): timeframe is TimeframeWithLocalTimes {
  return !!timeframe?.start && !!timeframe?.end
}

export function isEmpty(timeframe: Partial<TimeRangeControlFormValue>): timeframe is TimeframeWithLocalTimes {
  return !timeframe?.start && !timeframe?.end
}
